import { useEffect, useState } from 'react';
import { fetchSolanaTransaction } from '../api/transactions';

export function useSolanaTransaction(signature) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!signature?.trim()) {
      setData(null);
      setLoading(false);
      setError('Transaction signature is required.');
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);
    setData(null);

    fetchSolanaTransaction(signature.trim())
      .then((result) => {
        if (!cancelled) {
          setData(result);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          const message =
            err.response?.data?.message ||
            err.message ||
            'Failed to load transaction.';
          setError(message);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [signature]);

  return { data, loading, error };
}
